import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogsComponent } from './logs.component';
import { SharedModule } from '../../shared/shared.module';
import { LogsRoutes } from './logs.routes';

@NgModule({
  imports: [
    CommonModule,
    LogsRoutes,
    SharedModule
  ],
  declarations: [LogsComponent]
})
export class LogsModule { }
